import * as ambassadorWixPromoteMarketingV2AdsTxt from './promote-marketing-v2-ads-txt-ads-txt.http.js';
import * as ambassadorWixPromoteMarketingV2AdsTxtTypes from './promote-marketing-v2-ads-txt-ads-txt.types.js';
import * as ambassadorWixPromoteMarketingV2AdsTxtUniversalTypes from './promote-marketing-v2-ads-txt-ads-txt.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getAdsTxt(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixPromoteMarketingV2AdsTxtUniversalTypes.GetAdsTxtRequest,
  ambassadorWixPromoteMarketingV2AdsTxtTypes.GetAdsTxtRequest,
  ambassadorWixPromoteMarketingV2AdsTxtUniversalTypes.GetAdsTxtResponse,
  ambassadorWixPromoteMarketingV2AdsTxtTypes.GetAdsTxtResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPromoteMarketingV2AdsTxt.getAdsTxt(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/ads',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateAdsTxt(): __PublicMethodMetaInfo<
  'PUT',
  {},
  ambassadorWixPromoteMarketingV2AdsTxtUniversalTypes.UpdateAdsTxtRequest,
  ambassadorWixPromoteMarketingV2AdsTxtTypes.UpdateAdsTxtRequest,
  ambassadorWixPromoteMarketingV2AdsTxtUniversalTypes.UpdateAdsTxtResponse,
  ambassadorWixPromoteMarketingV2AdsTxtTypes.UpdateAdsTxtResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPromoteMarketingV2AdsTxt.updateAdsTxt(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PUT',
    path: '/v2/ads',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function appendAdsTxt(): __PublicMethodMetaInfo<
  'PATCH',
  {},
  ambassadorWixPromoteMarketingV2AdsTxtUniversalTypes.AppendAdsTxtRequest,
  ambassadorWixPromoteMarketingV2AdsTxtTypes.AppendAdsTxtRequest,
  ambassadorWixPromoteMarketingV2AdsTxtUniversalTypes.AppendAdsTxtResponse,
  ambassadorWixPromoteMarketingV2AdsTxtTypes.AppendAdsTxtResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPromoteMarketingV2AdsTxt.appendAdsTxt(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v2/ads',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  AdsTxt as AdsTxtOriginal,
  GetAdsTxtRequest as GetAdsTxtRequestOriginal,
  GetAdsTxtResponse as GetAdsTxtResponseOriginal,
  UpdateAdsTxtRequest as UpdateAdsTxtRequestOriginal,
  UpdateAdsTxtResponse as UpdateAdsTxtResponseOriginal,
  AppendAdsTxtRequest as AppendAdsTxtRequestOriginal,
  AppendAdsTxtResponse as AppendAdsTxtResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './promote-marketing-v2-ads-txt-ads-txt.types.js';
